const appConfigObj = {
  "version": 0.1,
  "name": "Configuratore Letto",
  "author": "VLK STUDIO",
  "companyInfo": {
    "name": "Casa Milano",
    "logoImgAlias": "logo"
  },
  "styles": {
    "primaryColor": "black",
    "secondaryColor": "white",
    "accent": "red",
    "fontAlias": "titillium"
  }
}

export default appConfigObj